import { ActivityLogParser } from '@/parsers/activityLog'
import { i18n } from '@/i18n'
import { kebabCase, upperFirst } from 'lodash'
import store from '@/store/store'
import { getFormFieldTranslationId } from '@/helpers/form'

export class UserActivityLogParser extends ActivityLogParser {
    static attributeDataTypes = {
        'roles.id': 'roles',
        'status': 'status',
    }

    static getLogDescriptionUpdated (activityLog, data) {
        const interpolationParams = {
            someone: data.causer,
            something: `${i18n.tc('common.change-log.subject.this.field', activityLog.attributeKeys.length)} <b>${activityLog.attributeLabels}</b>`,
        }

        if (activityLog.properties.attributes?.['person.name'] || activityLog.properties.old?.['person.name']) {
            interpolationParams.something = `<b>${i18n.tc('common.change-log.subject.this.linked-consultant')}</b>`
        }
        if (activityLog.properties.attributes?.['roles.id'] || activityLog.properties.old?.['roles.id']) {
            interpolationParams.something = `<b>${i18n.tc('common.change-log.subject.this.role--of-the-user', activityLog.properties.attributes?.['roles.id'].length || 2)}</b>`
        }
        if (activityLog.properties.attributes?.password !== undefined) {
            interpolationParams.something = `<b>${i18n.tc('common.change-log.subject.this.password', 1)}</b>`
        }

        if (data.causer) {
            return i18n.t('common.change-log.someone-updated-something', interpolationParams)
        } else {
            return upperFirst(i18n.tc('common.change-log.something-has-been-updated', activityLog.attributeKeys.length, interpolationParams))
        }
    }

    static getLogDetailsUpdated (activityLog, data) {
        const logDetails = []

        if (activityLog.properties.attributes?.['person.name'] || activityLog.properties.old?.['person.name']) {
            logDetails.push(
                {
                    key: 'linkedConsultant',
                    label: i18n.tc('forms.field.label.user.linked-consultant', 1),
                    oldValue: activityLog.properties.old?.['person.name'] ? `${activityLog.properties.old?.['person.name']} <span class="additional-info">(ID: ${activityLog.properties.old?.['person.id'] ?? '–'})</span>` : undefined,
                    newValue: activityLog.properties.attributes?.['person.name'] ? `${activityLog.properties.attributes?.['person.name']} <span class="additional-info">(ID: ${activityLog.properties.attributes?.['person.id'] ?? '–'})</span>` : undefined,
                }
            )
        }

        if (activityLog.properties.attributes?.['roles.id'] || activityLog.properties.old?.['roles.id']) {
            logDetails.push(
                {
                    key: 'roles.id',
                    label: i18n.tc('forms.field.label.user.roles-id', 2),
                    oldValue: activityLog.properties.old?.['roles.id'].map(roleId => store.state.roles[roleId]).join(', '),
                    newValue: activityLog.properties.attributes?.['roles.id'].map(roleId => store.state.roles[roleId]).join(', '),
                }
            )
        }

        if (activityLog.properties.attributes?.status || activityLog.properties.old?.status) {
            const newValue = activityLog.properties.attributes?.status
            const oldValue = activityLog.properties.old?.status

            if (this.checkValue(newValue)) this.newValue = this.getFormattedLogDetailValue(activityLog, 'status', undefined, newValue)
            if (this.checkValue(oldValue)) this.oldValue = this.getFormattedLogDetailValue(activityLog, 'status', undefined, oldValue)

            logDetails.push(
                {
                    label: i18n.tc(getFormFieldTranslationId({ type: 'label', context: kebabCase(activityLog.log_name), key: 'status' }), 1),
                    oldValue: this.oldValue,
                    newValue: this.newValue,
                }
            )
        }

        if (activityLog.properties.attributes?.email || activityLog.properties.old?.email) {
            logDetails.push(
                {
                    label: i18n.tc(getFormFieldTranslationId({ type: 'label', context: kebabCase(activityLog.log_name), key: 'status' }), 1),
                    oldValue: activityLog.properties.old?.email,
                    newValue: activityLog.properties.attributes?.email,
                }
            )
        }

        return logDetails
    }
}
